import placeholderUrl from '~/assets/images/event-placeholder.svg';

export function useEventPlaceholderImage() {
  return placeholderUrl;
}
